module.exports = __webpack_public_path__ + "static/media/17.92d1a68e.jpg";